import axios from "axios";
import { trim } from "lodash";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import {
    Link,
    useNavigate,
    useParams,
    useSearchParams
} from "react-router-dom";

import GallaryBox from "../../../Components/Global/GallaryBox";
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../../Context/AuthContext";
import { InputBlank, InputTypeCheckbox, InputTypeSelect, InputTypeText, InputTypeTextarea } from "../../../hooks/formsHandler/FormInputs";
import useGlobalFromData from "../../../hooks/formsHandler/useGlobalFromData";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import useMultipleImgUpload from "../../../hooks/useMultipleImgUpload";
import useToastify from "../../../hooks/useToastify";

function Addunits({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);
  const {
    onSelectFile,
    deleteHandler,
    uploadToserver,
    selectedImages,
    setSelectedImages,
    defaultImg,
    setdefaultImg,
    handleDefaultImage,
    ImgLinks,
    setImgLinks,
  } = useMultipleImgUpload();

    // show toast hook 
  const { notify } = useToastify();;

  const { stateData, dispatch } =useGlobalFromData();



  const route = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);


    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();;
  const { designation, userDetails } = useAuth();

  const [viewImageTwo, setViewImageTwo] = useState([]);


 
  const [categoryOption, setCategoryoption] = useState([
    {
      id: "Stove",
      name: "Stove",
    },
    {
      id: "Fridge",
      name: "Fridge",
    },
    {
      id: "Hot Water",
      name: "Hot Water",
    },
    {
      id: "Internet",
      name: "Internet",
    },
    {
      id: "Kitchen Hood",
      name: "Kitchen Hood",
    },
  ]);



  const value = useParams();
  const BuildId = value.id;
  const UnitId = searchParams.get("unitid");

  useEffect(() => {
    if (BuildId) {
      getBuildingValue();
    }
    if (UnitId) {
      getUnitValue();
    }
  }, [BuildId, UnitId]);

  const getUnitValue = () => {
    setLoading(true);
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `/unit/show/${UnitId}`,
    })
      .then((response) => {
        if (response?.data) {
          // setUnitData(response?.data);
          dispatch({ type: "load_data_api", payload: {...response.data,...JSON.parse(response?.data?.unit_category)}})


          
          if (response?.data?.unit_image) {
            setViewImageTwo(JSON.parse(response.data?.unit_image));
            const imgUrlMake = JSON.parse(response.data?.unit_image)?.map(
              (im) => ({ url: im })
            );
            setSelectedImages(imgUrlMake);
          }
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const getBuildingValue = () => {
    setLoading(true);
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `/building/show/${BuildId}`,
    })
      .then((response) => {
        setLoading(false);
     

        if (response.data.buildingDetails?.[0]) {

          const {status,...rest}=response.data.buildingDetails?.[0]
          dispatch({ type: "load_data_api", payload: {...rest , managerList:rest?.AssignBuildings?.map(manager=>({id:manager?.personaldetails_id, name:`${manager.User?.first_name} ${manager.User?.last_name}`}))}})

        }

        axiosFetch({
          axiosInstance: axios,
          method: "post",
          url: "tax/show",
          requestConfig: {
            country: response.data.buildingDetails?.[0]?.country,
            province: response.data.buildingDetails?.[0]?.province,
          },
        }).then((ress) => {
          // settaxInfo(ress?.data?.TaxDetails?.tax || {});

          dispatch({ type: "load_data_api", payload:{taxList:ress?.data?.TaxDetails?.tax,...ress?.data?.TaxDetails?.tax}})
        });
      })
      .catch((e) => {
        setLoading(false);
      });
  };


  const validation = () => {
    const errors = {};
    const allTextType = /^[a-zA-Z0-9' . - _ ! $ % @ & # ? : ; ^ ~,/*-]+$/;
    const onlyText = /^[a-zA-Z]+$/;
    const onlyNumber = /^[0-9]+$/;

    if (!stateData?.unit_name || !trim(stateData?.unit_name)) {
      errors.unit_name = "Please enter your Unit name.";
    }

    if (!stateData?.apartment_size || !trim(stateData?.apartment_size)) {
      errors.apartment_size = "Please enter your apartment size.";
    }

    // if (!trim(manager_id)) {
    //   errors.manager_id = "Please enter your manager.";
    // }

    if (!stateData?.unit_type || !trim(stateData?.unit_type)) {
      errors.unit_type = "Please enter your unit type.";
    }

    if (!stateData?.status || !trim(stateData?.status)) {
      errors.status = "Please enter your Status.";
    }
    if (selectedImages.length > 10) {
      errors.imgs = "Please choose images less than 10";
    }

    return errors;
  };

  const SubmitHandler = (e) => {
    e.preventDefault();
    const abc = validation();

dispatch({type:"ser_errors",payload:abc})
  

    if (Object.keys(abc).length == 0) {
      setLoading(true);
  
      const filterImages = selectedImages.filter(
        (file) => !file.url.includes("blob:")
      );
      const removeUrlTag = filterImages.map((img) => img.url);
      if (selectedImages.length == 0) {
        unitFuncWithImg([]);
      } else if (
        selectedImages.filter((img) => img.file !== undefined).length == 0
      ) {
        unitFuncWithImg(removeUrlTag);
      } else {
        uploadToserver("unit_image")
          .then((res) => {
            setImgLinks(res?.data?.links);

            // unitFuncWithImg(res?.data?.links);
            unitFuncWithImg([...res?.data?.links, ...removeUrlTag]);
          })
          .catch((err) => {
            setLoading(false);
          });
      }
    }
  };

  const unitFuncWithImg = (imagesss) => {
    const unitCtaegory = Object.keys(stateData)
.reduce((o, key) => {
  stateData[key] == true && (o[key] = stateData[key]);
  
  return o;
}, {});


    let data = {
      ...stateData,
      
      
      unit_image: JSON.stringify(imagesss),
      
      unit_category: unitCtaegory,
      building_id:BuildId,
   
      
    };
    
    






    setLoading(true);

    if (!UnitId) {
      axios
        .post("/unit/create", data)
        .then(function (response) {
          setLoading(false);
          if (response.status === 200) {
            route(`/building-details/${BuildId}`);
          }
        })
        .catch(function (error) {
          setLoading(false);
        });
    } else {
      axios
        .post(`/unit/update/${UnitId}`, data)
        .then(function (response) {
          setLoading(false);
          if (response.status === 200) {
            route(
              designation == "Owner" || designation == "Partner"
                ? `/building-details/${BuildId}`
                : `/${designation.toLowerCase()}/building-details/${BuildId}`
            );
          }
        })
        .catch(function (error) {
          setLoading(false);
        });
    }
  };



  const unitInputs =  [
    {
    
      name: "unit_name",
      type: "text",
      placeholder: "Unit Name",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
      label: "Unit Name",
      pattern: "^[A-Za-z0-9]{3,16}$",
      required: true,
      isShow: true,
      colSize:6,
      isReadOnly: false,
    },
   
    {
    
      name: "apartment_size",
      type: "text",
      placeholder: "Apartment Size(Sqft)",
      label: "Apartment Size(Sqft)",
      required: true,
      isShow: true,
      isReadOnly: false,
      colSize:6

    },
    {
    
      name: "building_code",
      type: "text",
      placeholder: "Building Code",
      label: "Building Code",
      required: true,
      isReadOnly: true,
      isShow: true,
           colSize:6,
         


    },
    {
    
      name: "unit_type",
      type: "selectbox",
      placeholder: "Type Of Unit",
      label: "Type Of Unit",
      required: true,
      isShow: true,
           colSize:6,
           isReadOnly: false,


    },



    {
    
      name: "bts",
      type: "text",
      placeholder: "Bts",
      label: "Bts",
      required: true,
      isShow: (stateData?.unit_type =="Industrial" || stateData?.unit_type =="Commercial") ? true :false ,


      colSize:2,

      isReadOnly: true,

    },
    {
    
      name: "gst",
      type: "text",
      placeholder: "Gst",
      label: "Gst",
      required: true,
      isShow: (stateData?.unit_type =="Industrial" || stateData?.unit_type =="Commercial") ? true :false ,



      colSize:2,


      isReadOnly: true,


    },
    {
    
      name: "hst",
      type: "text",
      placeholder: "Hst",
      label: "Hst",
      required: true,
      isShow: (stateData?.unit_type =="Industrial" || stateData?.unit_type =="Commercial") ? true :false ,



      colSize:2,


      isReadOnly: true,


    },
    {
    
      name: "pst",
      type: "text",
      placeholder: "Pst",
      label: "Pst",
      required: true,
      isShow: (stateData?.unit_type =="Industrial" || stateData?.unit_type =="Commercial") ? true :false ,



      colSize:2,


      isReadOnly: true,


    },
    {
    
      name: "qst",
      type: "text",
      placeholder: "Qst",
      label: "Qst",
      required: true,
      isShow: (stateData?.unit_type =="Industrial" || stateData?.unit_type =="Commercial") ? true :false ,


      colSize:2,

      isReadOnly: true,


    },

    {
    
      name: "unit_part",
      type: "selectbox",
      placeholder: "Unit Size",
      label: "Unit Size",
      required: true,
      isShow: (stateData?.unit_type =="Industrial" || stateData?.unit_type =="Commercial") ? true :false ,
      colSize:6,
      isReadOnly: false,


    },
    {
    
      name: "status",
      type: "selectbox",
      placeholder: "Status",
      label: "Status",
      required: true,
      isShow: true,
      colSize:6,
      isReadOnly: false,


    },
    {
    
      name: "manager_id",
      type: "selectbox",
      placeholder: "Choose Manager",
      label: "Manager",
      required: false,
      isShow: true,
      colSize:6,
      isReadOnly: false,



    },
    {
    
      name: "blank",
      type: "blank",
     
      colSize:6,
     
      placeholder: "Choose Manager",
      label: "Manager",
      required: true,
     
      isShow: (stateData?.unit_type =="Industrial" || stateData?.unit_type =="Commercial") ? true :false ,

    
      isReadOnly: false,


    },

    ...categoryOption?.map(category=>{

      
    return  {
       placeholder: `${category.name}`,
        label: `${category.name}`,
        required: true,
        isShow: true,
      isReadOnly: false,
isChecked:stateData?.[category.name] == true ? true : false,
        colSize:category.name.split(" ").length >2   ? 3 :2 ,
        type:"checkbox",
        name:`${category.id}`
      }}),
     
   
   
    {
     
      name: "unit_description",
      type: "textarea",
      placeholder: "Description",
      errorMessage: "It should be a valid email address!",
      label: "Description",
      required: true,
      isShow: true,
      colSize:12,
      isReadOnly: false,


    },

  ];


  const typeOfUnitList=[
     {
        id: "Commercial",
        name: "Commercial",
      },
      {
        id: "Residential",
        name: "Residential",
      },
      {
        id: "Industrial",
        name: "Industrial",
      },
     ]
  const UnitSizeList=[

   

     {
        id: "1-Bedroom",
        name: "1-Bedroom",
      },
     {
        id: "2-Bedroom",
        name: "2-Bedroom",
      },
     {
        id: "3-Bedroom",
        name: "3-Bedroom",
      },
      {
        id: "Studio",
        name: "Studio",
      },
      {
        id: "1/2",
        name: "1/2",
      },
      {
        id: "21/2",
        name: "21/2",
      },
      {
        id: "31/2",
        name: "31/2",
      },
      {
        id: "41/2",
        name: "41/2",
      },
      {
        id: "51/2",
        name: "51/2",
      },
     ]
    

     
  const statusList= ( UnitId && stateData?.Tenant?.first_name)  ? [
   
    {
      id: "Occupied",
      name: "Occupied",
    },
    {
      id: "Available",
      name: "Available",
    },
    {
      id: "Under-Renovation",
      name: "Under-Renovation",
    },
   
  ]

  :[ 
  {
    id: "Available",
    name: "Available",
  },
  {
    id: "Under-Renovation",
    name: "Under-Renovation",
  },];



  return (
    <>
      <DashboardLayouts>
        {allowLoading && <Loader />}

        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="d-flex align-items-center dashboard-upper-menu col-auto">
            <Link
              to="/dashboard"
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Dashboard</h3>
            </Link>
          </div>

          <div className="col-auto d-flex">
            <Link
              to={
                designation == "Owner" || designation == "Partner"
                  ? `/building-details/${BuildId}`
                  : `/${designation.toLowerCase()}/building-details/${BuildId}`
              }
              className="btn btn-outline-primary me-2"
            >
              Back To Unit List
            </Link>
          </div>
        </div>
        <div className="worker-heading w-100">
          <h1 className="heading-text">{stateData?.building_name}</h1>
        </div>

        <div className="add-request-form w-100">
          <h1 className="heading-text w-100 add-unit-heading">
            {!UnitId ? "Add Units" : "Edit Units"}
          </h1>
          <div
            className="gy-4 gx-xl-5
            "
          >
            <form className="row">
              <div className="col-xl-7 col-xxl-8">
                <div className="dash-form add-form">
                  <div className="row gy-4 gx-xl- 5">
                   


<>
                  {
                    unitInputs?.filter(buildingInput => (buildingInput.isShow)).map(({isChecked,type,isReadOnly,required,label,placeholder,colSize,name},index) =>{
                  
                 
                  
                  return    <>
                     
                     {
name=="blank" ?

<InputBlank   name={name} colSize={colSize} /> :


                      type=="selectbox" ?
                      
                      <InputTypeSelect
                      optionsList={name =="status" ? statusList : name =="unit_type"?  typeOfUnitList :  name =="unit_part"?  UnitSizeList : stateData?.managerList }
                      optionName={"name"}
                      isReadOnly={isReadOnly}
                        label={label}
                      type={type}
                      name={name}
                      required={required}
                      placeholder={placeholder}
                      errorMessage={stateData?.errorMessage?.[name]}
                      dispatch={dispatch}
                      stateData={stateData}
                      colSize={colSize}
                        />
                    
                    :
                    
                    
                    type=="textarea" ?   


                    <InputTypeTextarea
                    label={label}
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    isReadOnly={isReadOnly}
                    dispatch={dispatch}
                    required={required}
                    stateData={stateData}
                    errorMessage={stateData?.errorMessage?.[name]}
                    colSize={colSize} />
                     :  

                     type=="checkbox" ?   


                     <InputTypeCheckbox
                     label={label}
                     type={type}
                     isChecked={isChecked}
                     name={name}
                     placeholder={placeholder}
                     isReadOnly={isReadOnly}
                     dispatch={dispatch}
                     required={required}
                     stateData={stateData}
                     errorMessage={stateData?.errorMessage?.[name]}
                     colSize={colSize} />
                      : 


                 <InputTypeText
                 
                 label={label}
                 type={type}
                 name={name}
                 placeholder={placeholder}
                 errorMessage={stateData?.errorMessage?.[name]}
                 isReadOnly={isReadOnly}
                 dispatch={dispatch}
                 stateData={stateData}
                 colSize={colSize}
                 required={required}
                 />
                     }
                     
                        
                      </>
})
                  }
                </>


                  </div>
                </div>
              </div>

              <GallaryBox
                selectedImages={selectedImages}
                defaultImg={defaultImg}
                handleDefaultImage={handleDefaultImage}
                onSelectFile={onSelectFile}
                deleteHandler={deleteHandler}
              />
              <div>
                <button
                  type="submit"
                  // className="btn btn-primary btn-lg fs-6 mt-3 form-btn"
                  className="btn btn-primary btn-lg form-btn mt-4 "
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModalCenter"
                  onClick={(e) => {
                    SubmitHandler(e);
                  }}
                >
                  {!UnitId ? "Add now" : "Update now"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </DashboardLayouts>
    </>
  );
}

export default Addunits;
